import { MapPin, Clock, Route, Users, ArrowRight, Repeat } from "lucide-react";
import { Badge } from "@/components/ui/badge";

interface TripSummaryProps {
  from: string;
  to: string;
  distanceKm: number | null;
  durationMin: number | null;
  passengers: number;
  loadingRoute: boolean;
  routeType?: string;
}

const TripSummary = ({ from, to, distanceKm, durationMin, passengers, loadingRoute, routeType }: TripSummaryProps) => (
  <div className="space-y-4 mb-6">
    {routeType && (
      <Badge variant="secondary" className="mb-2 text-xs gap-1.5">
        {routeType === "round-trip" || routeType === "roundtrip" ? (
          <><Repeat className="w-3 h-3" /> Round Trip</>
        ) : (
          <><ArrowRight className="w-3 h-3" /> One Way</>
        )}
      </Badge>
    )}
    <div className="flex items-start gap-3">
      <MapPin className="w-5 h-5 text-primary shrink-0 mt-0.5" />
      <div>
        <p className="text-xs text-muted-foreground uppercase tracking-wide">Pick-up</p>
        <p className="text-foreground font-medium text-sm">{from}</p>
      </div>
    </div>
    <div className="flex items-start gap-3">
      <MapPin className="w-5 h-5 text-accent shrink-0 mt-0.5" />
      <div>
        <p className="text-xs text-muted-foreground uppercase tracking-wide">Drop-off</p>
        <p className="text-foreground font-medium text-sm">{to}</p>
      </div>
    </div>
    <div className="flex items-start gap-3">
      <Route className="w-5 h-5 text-muted-foreground shrink-0 mt-0.5" />
      <div>
        <p className="text-xs text-muted-foreground uppercase tracking-wide">Distance</p>
        <p className="text-foreground font-medium text-sm">
          {loadingRoute ? "Calculating..." : distanceKm ? `${distanceKm} km` : "—"}
        </p>
      </div>
    </div>
    <div className="flex items-start gap-3">
      <Clock className="w-5 h-5 text-muted-foreground shrink-0 mt-0.5" />
      <div>
        <p className="text-xs text-muted-foreground uppercase tracking-wide">Est. Time</p>
        <p className="text-foreground font-medium text-sm">
          {loadingRoute ? "Calculating..." : durationMin ? `~${durationMin} min` : "—"}
        </p>
      </div>
    </div>
    <div className="flex items-start gap-3">
      <Users className="w-5 h-5 text-muted-foreground shrink-0 mt-0.5" />
      <div>
        <p className="text-xs text-muted-foreground uppercase tracking-wide">Passengers</p>
        <p className="text-foreground font-medium text-sm">{passengers}</p>
      </div>
    </div>
  </div>
);

export default TripSummary;